import React from "react";
import "./Techstack.css";

import {
  SiReact, SiNodedotjs, SiExpress, SiMongodb,
  SiAngular, SiSpringboot, SiPython, SiDjango, SiNextdotjs,
  SiJavascript, SiCplusplus,
  SiGit, SiGithub, SiMui, SiNeo4J,
} from "react-icons/si";
import { FaJava } from "react-icons/fa";

const webData = [
  { icon: SiReact,      name: "React",      color: "#61DAFB" },
  { icon: SiAngular,    name: "Angular",    color: "#DD0031" },
  { icon: SiNextdotjs,  name: "Next.js",    color: "#e8e8e8" },
  { icon: SiNodedotjs,  name: "Node.js",    color: "#6CC24A" },
  { icon: SiExpress,    name: "Express",    color: "#9B9B9B" },
  { icon: SiMongodb,    name: "MongoDB",    color: "#47A248" },
];

const langData = [
  { icon: FaJava,       name: "Java",       color: "#f89820" },
  { icon: SiJavascript, name: "JavaScript", color: "#F7DF1E" },
  { icon: SiPython,     name: "Python",     color: "#3776AB" },
  { icon: SiCplusplus,  name: "C++",        color: "#00599C" },
];

const otherData = [
  { icon: SiSpringboot, name: "Spring Boot",  color: "#6DB33F" },
  { icon: SiDjango,     name: "Django",       color: "#4ade80" },
  { icon: SiNeo4J,      name: "Neo4j",        color: "#008CC1" },
  { icon: SiMui,        name: "Material UI",  color: "#007FFF" },
  { icon: SiGit,        name: "Git",          color: "#F05032" },
  { icon: SiGithub,     name: "GitHub",       color: "#e8e8e8" },
];

const Section = ({ title, items }) => (
  <div className="SBcover">
    <h2 className="SBHeading">{title}</h2>
    <div className="SBcontainer">
      {items.map(({ icon: Icon, name, color }) => (
        <div className="SBcard" key={name} title={name}>
          <Icon size={28} color={color} className="SBicon" />
          <span className="SBname">{name}</span>
        </div>
      ))}
    </div>
  </div>
);

const TechStack = () => {
  return (
    <div className="TCBox">
      <h1 className="TCHeader">Tech Stack</h1>
      <div className="stackBox">
        <Section title="Web Development"       items={webData}   />
        <Section title="Languages"             items={langData}  />
        <Section title="Tools & Frameworks"    items={otherData} />
      </div>
    </div>
  );
};

export default TechStack;